'use strict';

/**
 * Data Transformer Service
 * @constructor
 */
var DataTransformerService = function DataTransformerService() {
  /**
   * Maps data to given format
   *
   * @example
   * var data =  [
   *     {group: '(0-4)', current: 100, expected: 500},
   *     {group: '(5-10)', current: 1200, expected: 1000}
   * ];
   *
   * prepareData(data, ['current', 'expected', 'group'], ['m1', 'm2', 'group']);
   *
   * Will return:
   * [
   *     {group: '(0-4)', m1: 100, m2: 500},
   *     {group: '(5-10)', m1: 1200, m2: 1000}
   * ];
   *
   *
   * @param {Array} data - array with chart data
   * @param {string[]} mapFrom - arrays of properties names from data to be mapped
   * @param {string[]} mapTo - arrays of properties for result array
   * @returns {Array}
   */
  function prepareData(data, mapFrom, mapTo) {
    var result = [];
    if (mapFrom.length !== mapTo.length) {
      throw Error();
    }
    var dataLen = data.length;
    var fieldsToPickLen = mapFrom.length;
    for (var i = 0; i < dataLen; i++) {
      var elem = data[i];
      var obj = Object.create(null);
      for (var j = 0; j < fieldsToPickLen; j++) {
        obj[mapTo[j]] = elem[mapFrom[j]];
      }
      result.push(obj);
    }
    return result;
  }
  return {
    prepareData: prepareData
  };
};
DataTransformerService.$inject = [];
module.exports = DataTransformerService;